import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AuthService, SessionService } from '@auth/auth';
import { concatMap, EMPTY, Observable, switchMap, take } from 'rxjs';
import { v4 } from 'uuid';
import { APP_ENVIRONMENT, AppEnvironment } from '../app.environment';
import { UserecoApiService } from '../services/usereco-api.service';

/**
 * This should be added first in the interceptors list so that it'll be overridden by the MFEs' interceptors.
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  var1: string | undefined;
  var2: string | undefined;

  constructor(
    @Inject(APP_ENVIRONMENT) appEnvironment: AppEnvironment,
    private sessionService: SessionService,
    private auth: AuthService,
    private userEcoApiService: UserecoApiService
  ) {
    this.var1 = appEnvironment.var1;
    this.var2 = appEnvironment.var2;
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return this.auth.isAuthenticated$.pipe(
      take(1),
      switchMap((isAuthenticated) => {
        if (!isAuthenticated) {
          return EMPTY;
        }
        return this.sessionService.getAccessTokenSilently().pipe(
          concatMap((token) => {
            request = request.clone({
              setHeaders: {
                Authorization: `Bearer ${token ?? 'none'}`,
                client_id: `${this.var1}`,
                client_secret: `${this.var2}`,
                'Caller-Id':
                  request.headers.get('Caller-Id') || 'UserEcosystem App',
                'Issued-By':
                  request.headers.get('Issued-By') || 'UserEcosystem App',
                'Request-Id': v4(),
                'Session-Id': this.userEcoApiService.getSessionId()
              }
            });
            return next.handle(request);
          })
        );
      })
    );
  }
}
